import { useState } from 'react';
import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import FormikInput from 'components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import walkthroughIds from '../walkthroughIds';

const DescriptionField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.description && touched.description}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(true), height: '100px' }}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Description
                </FormLabel>
                <Field
                    as={FormikInput}
                    id="description"
                    name="description"
                    placeholder="Short summary of what this offering provides."
                    maxLength={1000}
                    multiline
                    data-walkthroughid={
                        walkthroughIds.createMode.ufDescriptionInput
                    }
                    error={errors.description}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Short summary of what this offering provides."
                        ariaLabel="catalog-description-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default DescriptionField;
